"use strict";
const FileFactory = require("./src/FileFactory");
const File = require("./src/File");
const Zip = require("./src/Zip");

class IO {
    constructor() {
        this.fileFactory = new FileFactory();
        this.File = File;
        this.Zip = Zip;
    }
}

module.exports = IO;
